import { find } from 'lodash-es';
import DebouncedToggle from '../debounced-toggle';

import template from './table-column-selector.html';
import * as TableColumnActions from '../../state/table-columns/table-columns.action';

export class TableColumnSelectorController extends DebouncedToggle {
  constructor($ngRedux, $timeout) {
    'ngInject';
    super($timeout);

    this.store = $ngRedux;
    this.$timeout = $timeout;
    this._toggleInProgress = false;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, TableColumnActions)(this);

    this.defaultBindings();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    const { attributes, tableColumns } = state;

    return {
      attributes: attributes,
      tableColumns: tableColumns
    };
  }

  hideList() {
    this._debounceToggle()
      .then(() => (this.showList = false))
      .catch(this._ignore);
  }

  toggleShowList() {
    this._debounceToggle()
      .then(() => (this.showList = !this.showList))
      .catch(this._ignore);
  }

  defaultBindings() {
    if (this.attributes == null) {
      this.attributes = {};
    }

    if (this.tableColumns == null) {
      this.tableColumns = {};
    }
  }

  selected(column) {
    return find(this.tableColumns.selected, selected => selected.key === column.key);
  }
}

export const tableColumnSelectorComponent = {
  template,
  restrict: 'E',
  replace: true,
  bindings: {},
  controller: 'TableColumnSelectorController as vm'
};
